export default {
      id: "arrow-bottom-top-usage",
      viewBox: "0 0 28 22",
      url: __webpack_public_path__ + "img/icons.svg#arrow-bottom-top",
      toString: function () {
        return this.url;
      }
    }